import {Badge} from '@mantine/core';
import {ExecutionStatus} from '../types.ts';

const colorByStatus: Record<ExecutionStatus, string> = {
    [ExecutionStatus.PENDING]: 'gray',
    [ExecutionStatus.RUNNING]: 'blue',
    [ExecutionStatus.SUCCEEDED]: 'green',
    [ExecutionStatus.FAILED]: 'red',
    [ExecutionStatus.CANCELLED]: 'orange',
    [ExecutionStatus.TIMED_OUT]: 'red',
};

export const ExecutionStatusBadge = ({status}: { status?: ExecutionStatus }) => {
    if (!status) {
        return <Badge color={'gray'} variant={'light'}>UNKNOWN</Badge>;
    }
    return (
        <Badge color={colorByStatus[status] ?? 'gray'} variant={'light'}>
            {status}
        </Badge>
    );
};
